export const MANUAL = 0
export const AUTO = 1

export const TYPES = {
  [MANUAL]: 'Manual',
  [AUTO]: 'Auto'
}
